<template>
  <div class="min-h-full p-4">
    <div class="container">
      <button type="button" @click="handleBack" class="mb-6 back-btn">
        <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
        返回
      </button>

      <div class="header">
        <div class="inline-flex items-center justify-center w-16 h-16 gradient-button rounded-full mb-4 shadow-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h10"/></svg>
        </div>
        <h1 class="title">HTTP 接口文档</h1>
        <p class="subtitle">使用 API Key 调用公共 hash-to-phone 接口</p>
      </div>

      <div class="disclaimer" role="note">
        本功能为实验性功能，不做 SLA 保证，请勿在生产环境或业务核心链路上使用。
      </div>

      <div class="main-card">
        <h2 class="section-title">服务地址</h2>
        <p class="section-desc mb-3"></p>
        <div class="code-block">{{ baseUrl }}</div>
      </div>

      <div class="main-card">
        <h2 class="section-title">鉴权</h2>
        <p class="section-desc mb-4">所有公共接口均需 API Key。在 <router-link to="/settings/api-keys" class="link">API Key 管理</router-link> 页面创建 Key 后，通过请求头传递：</p>
        <div class="code-block">X-API-Key: ph_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</div>
        <p class="hint mt-4">未携带或 Key 无效时返回 HTTP 401，业务码 2004 / 2002。</p>
      </div>

      <div class="main-card">
        <h2 class="section-title">响应格式</h2>
        <p class="section-desc mb-3">统一 JSON 信封：</p>
        <div class="code-block">{ "code": 0, "message": "success", "data": { ... } }</div>
        <p class="hint mt-3"><code class="code-inline">code === 0</code> 表示成功；非 0 为业务错误（如 6001 限流）。</p>
      </div>

      <div class="main-card">
        <h2 class="section-title">Hash 查手机号</h2>
        <div class="endpoint">
          <span class="method post">POST</span>
          <code class="path">/v1/query</code>
        </div>
        <p class="section-desc mt-3 mb-4">根据 MD5、SHA256 或国密 SM3 摘要查询手机号。</p>

        <h3 class="sub-title">请求体</h3>
        <div class="code-block">{ "hash": "bfdc153c0a635d3d49c082afeb4e0bba" }</div>
        <ul class="param-list">
          <li><code class="code-inline">hash</code>（必填）：十六进制字符串。MD5 为 32 字符；SHA256 / SM3 为 64 字符。</li>
        </ul>

        <h3 class="sub-title">成功响应 data 字段</h3>
        <div class="code-block">{
  "hash": "bfdc153c0a635d3d49c082afeb4e0bba",
  "phone": "13000000001",
  "found": true,
  "hash_type": "MD5",
  "duration_ms": 12
}</div>
        <ul class="param-list">
          <li><code class="code-inline">found</code>：是否命中库内数据</li>
          <li><code class="code-inline">hash_type</code>：命中时为 MD5 / SHA256 / SM3，未命中为空</li>
          <li><code class="code-inline">phone</code>：命中时为手机号；未命中或格式错误时为说明文案</li>
        </ul>

        <h3 class="sub-title">限流</h3>
        <p class="section-desc">每个 API Key 每分钟最多 30 次（与页面单次查询频控一致，独立计数）；超出返回 HTTP 429，业务码 6001。</p>

        <h3 class="sub-title">cURL 示例</h3>
        <div class="code-block">curl -X POST '{{ baseUrl }}/v1/query' \
  -H 'Content-Type: application/json' \
  -H 'X-API-Key: ph_你的密钥' \
  -d '{"hash":"bfdc153c0a635d3d49c082afeb4e0bba"}'</div>
      </div>
    </div>
  </div>
</template>

<script>
import { PUBLIC_API_URL } from '../utils/seo.js';

export default {
  name: 'ApiDocs',
  computed: {
    baseUrl() {
      return PUBLIC_API_URL;
    }
  },
  methods: {
    handleBack() {
      this.$router.push('/single');
    }
  }
};
</script>

<style scoped>
.container { max-width: 800px; margin: 0 auto; }
.header { text-align: center; margin-bottom: 2rem; }
.title { font-size: 1.75rem; font-weight: 700; color: #111827; margin-bottom: 0.5rem; }
.subtitle { color: #6b7280; }
.disclaimer {
  margin-bottom: 1.5rem;
  padding: 0.875rem 1rem;
  border-radius: 0.75rem;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  color: #92400e;
  font-size: 0.875rem;
  line-height: 1.6;
  text-align: center;
}
.back-btn {
  display: flex; align-items: center; gap: 0.5rem;
  background: linear-gradient(to right, #6366f1, #4f46e5);
  color: white; padding: 0.375rem 0.75rem; border-radius: 0.75rem;
  font-weight: 500; transition: all 0.3s;
}
.back-btn:hover { filter: brightness(1.05); }
.main-card {
  background: rgba(255,255,255,0.85); backdrop-filter: blur(12px);
  border-radius: 1.5rem; padding: 1.5rem; margin-bottom: 1.5rem;
  box-shadow: 0 10px 40px rgba(0,0,0,0.06); border: 1px solid rgba(255,255,255,0.3);
}
.section-title { font-size: 1.125rem; font-weight: 600; color: #111827; margin-bottom: 0.5rem; }
.sub-title { font-size: 0.9375rem; font-weight: 600; color: #374151; margin: 1.25rem 0 0.5rem; }
.section-desc { font-size: 0.875rem; color: #6b7280; line-height: 1.6; }
.hint { font-size: 0.8125rem; color: #9ca3af; }
.link { color: #2563eb; text-decoration: underline; }
.code-block {
  background: #1e293b; color: #e2e8f0; padding: 1rem; border-radius: 0.75rem;
  font-family: ui-monospace, monospace; font-size: 0.8125rem; line-height: 1.6;
  overflow-x: auto; white-space: pre-wrap; word-break: break-all;
}
.code-inline {
  background: #f3f4f6; padding: 0.125rem 0.375rem; border-radius: 0.25rem;
  font-family: ui-monospace, monospace; font-size: 0.8125rem;
}
.endpoint { display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap; }
.method { font-size: 0.75rem; font-weight: 700; padding: 0.25rem 0.5rem; border-radius: 0.375rem; }
.method.post { background: #dbeafe; color: #1d4ed8; }
.path { font-family: ui-monospace, monospace; font-size: 0.9375rem; color: #111827; }
.param-list { margin: 0.75rem 0 0; padding-left: 1.25rem; font-size: 0.875rem; color: #4b5563; line-height: 1.7; }
</style>
